import React from 'react';
import PaymentGateways from '../../components/AdminNext/PaymentGateways';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Payment gateways — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <PaymentGateways />
      </HeadLessLayout>
    )
  };
}

export default action;
